export default "__VITE_ASSET__BbkimdNt__"